<template>
  <el-select :placeholder="props.placeholder || $t('common.please.select')" style="width: 200px"
             :model-value="props.modelValue"
             @change="emitValue"
             popper-class="my-select"
             :filter-method="customFilter"
             filterable
             size="small"
             :loading="props.loading"
             loading-text=""
  >
    <!-- 循环 -->
    <el-option :value="9999" :label="$t('customer.select')" v-if="props.newCusomerFlag"/>
    <div ref="scrollContainerRef" @scroll="handleScroll" :style="`max-height: ${props.newCusomerFlag ? 226 : 260}px;overflow-y: scroll;`">
      <el-option v-for="item in customerListAll" :label="item.customerName" :value="item.id"
                 :key="item.id">
        <template #default>
          <div class="inner_select">
            {{ item.customerName }}
          </div>
        </template>
      </el-option>
      <ElSelectLoading
          v-if="isFetchingPage"
          :hasMore="true"
          :loadingText="$t('common.loading')"
      />
      <ElSelectLoading
          v-else
          :hasMore="isFinish"
          :loadingText="$t('common.loading')"
      />
      <!--      <el-option v-if="loadingCustomer" :value="null" disabled>{{ $t('common.loading') }}</el-option>-->
    </div>
  </el-select>
</template>

<script setup>
import {defineProps, onMounted, ref, watch, defineExpose, computed} from 'vue';
import {ElMessage} from 'element-plus';
import {requestAllCustomer} from '../api/customer';
import {debouncePlus, throttle} from "@/utils/mylodash";
import {useStore} from "vuex";
import ElSelectLoading from "@/components/Select/ElSelectLoading.vue";

const store = useStore()
const props = defineProps({
  modelValue: [String, Number],
  teamId: Number,
  placeholder: {type: String, default: () => ''},
  modelModifiers: {default: () => ({})},
  newCusomerFlag: {default: () => false, type: Boolean},
  loading: {type: Boolean, default: () => false},
})
const customerListAll = computed(() => store.state.customer.customerListAll)
const loadingCustomer = ref(false);
const isFetchingPage = ref(false)
const lastLoadTs = ref(0)
const loadCooldownMs = 500
const bottomThresholdPx = 320
const canTriggerLoadMore = ref(true)
const page = ref(1);
const size = ref(20);
const total = ref(0);
// true = 还有更多数据；false = 已到最后一页
const hasMore = ref(true);
const scrollContainerRef = ref(null)


const emit = defineEmits(['update:modelValue', 'change', 'loaded', 'loading']);

function emitValue(value) {
  console.log('组件更新', value);
  emit('update:modelValue', value);
  emit('change', value);
}

// 首次搜索要清空
const isSearch = ref(true)

async function getAllCustomer(val) {
  if (isFetchingPage.value) return
  isFetchingPage.value = true

  // 只有首次加载/搜索时才显示 loading，分页追加时不闪烁
  const showLoading = page.value === 1
  const prevScrollTop = scrollContainerRef.value?.scrollTop
  if (showLoading) {
    loadingCustomer.value = true
    emit('loading', true)
  }

  await requestAllCustomer({
    teamId: props.teamId,
    type: 1,
    pageNo: page.value,
    pageSize: size.value,
    search: search.value,
  }).then(async (res) => {
    console.log('客户列表', res);
    const records = res?.result?.records || []
    total.value = Number(res?.result?.total || 0)

    if (records.length > 0 || page.value === 1) {
      // if (props.newCusomerFlag) {
      //   res.result.records.unshift({id: 9999, customerName: "新建客户"});
      // }
      if (search.value !== "" && search.value !== undefined && search.value !== undefined && isSearch.value) {
        await store.commit("customer/setCustomerListAll", [])
        isSearch.value = false
      }
      const payload = [...customerListAll.value, ...records].reduce((acc, current) => {
        if (!acc.some(item => item.id === current.id)) {
          acc.push(current);
        }
        return acc;
      }, []);
      await store.commit("customer/setCustomerListAll", payload)
      emit('loaded', payload)
    } else {
      hasMore.value = false
      emit('loaded', [])
    }

    // 是否还有更多（true = 还有更多，可以继续翻页）
    if (total.value > 0) {
      hasMore.value = page.value * size.value < total.value
    } else {
      // 后端未返回 total 时，按本次返回数量判断
      hasMore.value = records.length >= size.value
    }

    if (showLoading) {
      loadingCustomer.value = false
      emit('loading', false)
    }

    // 分页追加时尽量保持滚动位置，避免闪一下/跳动
    if (!showLoading && typeof prevScrollTop === 'number' && scrollContainerRef.value) {
      scrollContainerRef.value.scrollTop = prevScrollTop
    }
  }).catch(e => {
    ElMessage.error(e);
    loadingCustomer.value = false
    emit('loading', false)
    emit('loaded', [])
  }).finally(() => {
    if (page.value === 1) {
      loadingCustomer.value = false
      emit('loading', false)
    }
    isFetchingPage.value = false
  });
}

const loadNextPage = async () => {
  if (isFetchingPage.value) return
  if (!hasMore.value) return
  page.value = page.value + 1
  await getAllCustomer()
}

const search = ref('')
const customFilter = debouncePlus((val) => {
  isSearch.value = true
  page.value = 1
  search.value = val
  hasMore.value = true
  canTriggerLoadMore.value = true
  getAllCustomer()
}, 1000)

const handleScroll = throttle((event) => {
  console.log('getAllCustomer=======')
  const el = event?.target
  if (!el) return
  if (isFetchingPage.value) return

  const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight
  const dynamicThreshold = Math.floor(el.clientHeight * 0.75)
  const threshold = Math.max(bottomThresholdPx, dynamicThreshold)

  // 用户滚离底部一定距离后，重新“解锁”下一次触发
  if (distanceToBottom > threshold) {
    canTriggerLoadMore.value = true
    return
  }

  // 已经到最后一页就不再分页
  if (!hasMore.value) return
  // 底部区域只触发一次，避免停留在底部时连续请求
  if (!canTriggerLoadMore.value) return

  const now = Date.now()
  if (now - lastLoadTs.value < loadCooldownMs) return
  lastLoadTs.value = now

  canTriggerLoadMore.value = false
  loadNextPage()
}, 100)

async function initGetAllCustomer() {
  if (isFetchingPage.value) return
  await store.commit("customer/setCustomerListAll", [])
  page.value = 1;
  hasMore.value = true;
  canTriggerLoadMore.value = true
  getAllCustomer();
}

watch(() => props.teamId, () => {
  console.log(props.teamId);
  initGetAllCustomer();
});

defineExpose({
  initGetAllCustomer,
  getAllCustomer,
});

onMounted(() => {
  // getAllCustomer();
  search.value = ""
});
</script>

<style lang="less" scoped>
.inner_select {
  width: auto;
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
